import Image from 'next/image'
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { PLAYER_SEARCH_QUERY } from "@constants/players"

export interface PlayerProfile {
  id: string
  name: string
  team: string
  image?: string
}

interface PlayerCardProps {
  /** Player data to display */
  player: PlayerProfile
}

/**
 * Reusable player card component used in player carousels.
 * Renders a linked player image with their name below.
 */
export default function PlayerCard({ player }: PlayerCardProps) {
  const searchQuery = PLAYER_SEARCH_QUERY[player.id] ?? player.name

  return (
    <LocalizedClientLink
      href={`/results/${encodeURIComponent(searchQuery)}`}
      className="group block flex-shrink-0 w-[140px] md:w-[188px] outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2 rounded-xl"
    >
      {/* Player Image */}
      <div className="relative w-[140px] h-[185px] md:w-[188px] md:h-[250px] overflow-hidden rounded-xl bg-gray-100">
        {player.image ? (
          <Image
            src={player.image}
            alt={player.name}
            fill
            className="object-cover group-hover:scale-105 transition-transform duration-300"
            sizes="(max-width: 768px) 140px, 188px"
          />
        ) : (
          <div className="w-full h-full bg-gray-100" />
        )}
      </div>
      {/* Player Name */}
      <div className="pt-2 md:pt-3 text-center">
        <h3 className="font-semibold text-xs md:text-base text-brand-navy group-hover:text-brand-hero-navy transition-colors">
          {player.name}
        </h3>
      </div>
    </LocalizedClientLink>
  )
}
